import './scss/pages/page-single-post.scss';
import { initContentScrollNav } from './js/front/content-scroll-nav';
import { initSocialShareCopyLink } from './js/front/social-share';
import { initTocToggle } from './js/front/toc-toggle';
import { initListDescriptionIndent } from './js/front/list-description-indent';

initContentScrollNav();
initSocialShareCopyLink();
initTocToggle();
initListDescriptionIndent();
